import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'

import { authenticationService } from '@/services/Login'
import { useLoading } from '@/hooks/useLoading'

function ConfirmCpf() {
  const [information, setInformation] = useState('')
  const { SET_LOADING } = useLoading()

  useEffect(() => {
    prepareObject()
  }, [])

  function prepareObject() {
    let params = new URLSearchParams(window.location.search)
    const userId = params.get('userId')
    const newCpf = params.get('newCpf')
    const token = params.get('token')
    const obj = {
      userId,
      newCpf,
      token
    }
    submit(obj)
  }

  async function submit(obj: any) {
    try {
      SET_LOADING(true)
      await authenticationService.changeCpf(obj)
      setInformation('Seu CPF foi alterado com sucesso.')
    } catch (e: any) {
      setInformation('Não foi possível alterar seu cpf, favor tentar novamente')
    } finally {
      SET_LOADING(false)
    }
  }

  return (
    <Box
      display="flex"
      py="77px"
      px={{ md: '16px', xs: '16px' }}
      maxWidth={515}
      m="auto"
      justifyContent="center"
      alignItems="center"
      width="100%"
      flexDirection="column"
    >
      <Typography
        textAlign="center"
        fontSize="30px"
        width="100%"
        marginBottom="8px"
      >
        Alteração de CPF
      </Typography>
      <Typography
        textAlign="center"
        fontSize="18px"
        width="100%"
        marginBottom="36px"
      >
        {information}
      </Typography>
    </Box>
  )
}

export default ConfirmCpf
